export const ApiEntityUnits = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async (id, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/units`)
    return result.data
  }

  const save = async (id, aid, payload, module = 'accommodations') => {
    console.log(`/api/entities/${module}/${aid}/units/${id}`, payload)
    const result = await axios.post(`/api/entities/${module}/${aid}/units/${id}`, payload)
    return result.data
  }

  const remove = async (id, aid, module = 'accommodations') => {
    const result = await axios.delete(`/api/entities/${module}/${aid}/units/${id}`)
    return result.data
  }

  const find = async (id, aid, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${aid}/units/${id}`)
    return result.data
  }

  return {
    entityUnitsFind: find,
    entityUnitsLoad: load,
    entityUnitsSave: save,
    entityUnitsRemove: remove
  }
}
